(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-native-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const selector = '.mova-native-hero';
    const videoSelector = '.mova-native-hero__video';

    const getVisibleVideos = (hero) => {
      return Array.from(hero.querySelectorAll(videoSelector)).filter((video) => {
        return window.getComputedStyle(video).display !== 'none';
      });
    };

    const prepareVideo = (video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
    };

    const markBlockedIfNeeded = (hero, videos) => {
      if (!videos.length) return;
      const blocked = videos.every((video) => video.paused || video.readyState < 2);
      hero.classList.toggle('mova-native-hero--video-blocked', blocked);
    };

    const playHeroVideo = (hero) => {
      const videos = getVisibleVideos(hero);
      if (!videos.length) return;

      hero.classList.remove('mova-native-hero--video-blocked');

      const attempts = videos.map((video) => {
        prepareVideo(video);
        const playAttempt = video.play();

        video.addEventListener('playing', () => {
          hero.classList.remove('mova-native-hero--video-blocked');
        }, { once: true });

        if (playAttempt && typeof playAttempt.then === 'function') {
          return playAttempt;
        }

        return Promise.resolve();
      });

      Promise.allSettled(attempts).then(() => {
        window.setTimeout(() => markBlockedIfNeeded(hero, videos), 250);
      });

      window.setTimeout(() => markBlockedIfNeeded(hero, videos), 1600);
    };

    const initHero = (hero) => {
      if (initialized.has(hero)) return;
      initialized.add(hero);
      playHeroVideo(hero);
    };

    const init = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initHero);
    };

    const retry = () => {
      document.querySelectorAll(selector).forEach(playHeroVideo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('touchstart', retry, { once: true, passive: true });
    document.addEventListener('pointerdown', retry, { once: true, passive: true });
    document.addEventListener('click', retry, { once: true, passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-review-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.mova-review');

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const form = section.querySelector('.mova-review__form');
      const frame = section.querySelector('.mova-review__response-frame');
      const invalid = section.querySelector('.mova-review__invalid');
      const success = section.querySelector('.mova-review__success');
      const submit = section.querySelector('.mova-review__submit');
      const status = section.querySelector('.mova-review__status');
      const comment = form?.querySelector('[name="comment"]');
      const counter = form?.querySelector('[data-character-count]');
      const photoInput = form?.querySelector('[data-photo-input]');
      const photoPicker = form?.querySelector('.mova-review__photo-picker');
      const photoPreview = form?.querySelector('[data-photo-preview]');
      const photoPreviewImage = photoPreview?.querySelector('img');
      const photoName = photoPreview?.querySelector('[data-photo-name]');
      const removePhoto = photoPreview?.querySelector('[data-remove-photo]');
      const tokenInput = form?.querySelector('[name="token"]');
      const sourceInput = form?.querySelector('[name="source"]');
      const startedAtInput = form?.querySelector('[name="started_at"]');
      const endpoint = section.dataset.endpoint;
      const buttonLabel = section.dataset.buttonLabel;
      const requireToken = section.dataset.requireToken === 'true';
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token') || '';
      const source = params.get('source') === 'sachet' ? 'sachet' : 'web';
      let submitted = false;
      let photoPreviewUrl = '';
      const photoMaxBytes = 15 * 1024 * 1024;
      const photoTypes = [
        'image/jpeg',
        'image/jpg',
        'image/pjpeg',
        'image/png',
        'image/webp',
        'image/heic',
        'image/heif',
        'image/heic-sequence',
        'image/heif-sequence'
      ];
      const photoExtensionPattern = /\.(jpe?g|png|webp|heic|heif)$/i;

      if (!form) return;

      tokenInput.value = token;
      sourceInput.value = source;
      startedAtInput.value = String(Date.now());
      form.action = endpoint;

      if (!endpoint && !window.Shopify?.designMode) {
        form.hidden = true;
        invalid.hidden = false;
        invalid.querySelector('h2').textContent = 'Formulario temporalmente no disponible';
        invalid.querySelector('p').textContent = 'Inténtalo nuevamente más tarde.';
        return;
      }

      if (requireToken && !token && !window.Shopify?.designMode) {
        form.hidden = true;
        invalid.hidden = false;
        return;
      }

      comment?.addEventListener('input', () => {
        counter.textContent = `${comment.value.length} / 800`;
      });

      const showError = (name, show) => {
        const error = form.querySelector(`[data-error-for="${name}"]`);
        if (error) error.hidden = !show;
      };

      const isValidPhoto = (file) => {
        if (!file || file.size > photoMaxBytes) return false;
        const type = (file.type || '').toLowerCase();
        return photoTypes.includes(type) || photoExtensionPattern.test(file.name || '');
      };

      const clearPhoto = () => {
        if (photoPreviewUrl) URL.revokeObjectURL(photoPreviewUrl);
        photoPreviewUrl = '';
        photoInput.value = '';
        photoPreviewImage.removeAttribute('src');
        photoPreviewImage.hidden = false;
        photoName.textContent = '';
        photoPreview.classList.remove('mova-review__photo-preview--no-image');
        photoPreview.hidden = true;
        photoPicker.hidden = false;
        showError('photo', false);
      };

      photoInput?.addEventListener('change', () => {
        const file = photoInput.files?.[0];
        if (!file) {
          clearPhoto();
          return;
        }

        const isValid = isValidPhoto(file);
        showError('photo', !isValid);
        if (!isValid) {
          photoInput.value = '';
          return;
        }

        if (photoPreviewUrl) URL.revokeObjectURL(photoPreviewUrl);
        photoPreviewUrl = URL.createObjectURL(file);
        photoPreviewImage.hidden = false;
        photoPreview.classList.remove('mova-review__photo-preview--no-image');
        photoPreviewImage.src = photoPreviewUrl;
        photoName.textContent = file.name;
        photoPicker.hidden = true;
        photoPreview.hidden = false;
      });

      photoPreviewImage?.addEventListener('error', () => {
        photoPreviewImage.hidden = true;
        photoPreview.classList.add('mova-review__photo-preview--no-image');
      });

      removePhoto?.addEventListener('click', clearPhoto);

      const validate = () => {
        const stars = form.querySelector('[name="stars"]:checked');
        const name = form.querySelector('[name="name"]');
        const consent = form.querySelector('[name="consent"]');
        const photo = photoInput?.files?.[0];
        const isStarsValid = Boolean(stars);
        const isCommentValid = comment.value.trim().length >= 10;
        const isNameValid = name.value.trim().length >= 2;
        const isConsentValid = consent.checked;
        const isPhotoValid =
          !photo || isValidPhoto(photo);

        showError('stars', !isStarsValid);
        showError('comment', !isCommentValid);
        showError('name', !isNameValid);
        showError('consent', !isConsentValid);
        showError('photo', !isPhotoValid);

        return isStarsValid && isCommentValid && isNameValid && isConsentValid && isPhotoValid;
      };

      form.addEventListener('submit', (event) => {
        status.textContent = '';
        if (!validate()) {
          event.preventDefault();
          form.querySelector('[aria-invalid="true"]')?.focus();
          return;
        }

        if (!endpoint) {
          event.preventDefault();
          status.textContent = 'Falta conectar el formulario.';
          return;
        }

        submitted = true;
        submit.disabled = true;
        submit.querySelector('span').textContent = 'Enviando...';
      });

      window.addEventListener('message', (event) => {
        if (event.source !== frame.contentWindow) return;
        if (event.data?.type !== 'mova-review-response' || !submitted) return;

        submitted = false;
        if (event.data.ok) {
          form.hidden = true;
          success.hidden = false;
          success.setAttribute('tabindex', '-1');
          success.focus();
          return;
        }

        submit.disabled = false;
        submit.querySelector('span').textContent = buttonLabel;
        status.textContent = event.data.message || 'No pudimos guardar tu reseña. Inténtalo nuevamente.';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
